import type {
  OptimizationJson,
  OptimizationState,
  OptimizationVariation,
} from '@packages/systems/optimization/types';

export const MOCK_OPTIMIZATION_JSON: OptimizationJson = {
  id: 'customerId',
  pages: {},
  events: {},
  version: 0,
  experiences: {
    '417219064': {
      id: '417219064',
      campaignId: '217219064',
      name: 'experienceName',
      variations: {
        '617083500': {
          name: 'Base',
          state: 'draft',
          statusLabel: 'Draft',
          isBaseVariation: true,
          experienceId: '417219064',
          id: '617083500',
        },
        '617083510': {
          name: 'Variation A',
          state: 'draft',
          statusLabel: 'Draft',
          isRbpFallBack: false,
          isRedirectVariation: false,
          isMissingPageData: false,
          experienceId: '417219064',
          id: '617083510',
        },
        '617083508': {
          name: 'Variation B',
          state: 'draft',
          statusLabel: 'Draft',
          isBaseVariation: false,
          isRbpFallBack: false,
          isRedirectVariation: false,
          isMissingPageData: false,
          experienceId: '417219064',
          id: '617083508',
        },
      },
    },
  },
} as unknown as OptimizationJson;

export const VARIATIONS: OptimizationVariation[] = [
  MOCK_OPTIMIZATION_JSON.experiences['417219064']!.variations['617083510']!,
  MOCK_OPTIMIZATION_JSON.experiences['417219064']!.variations['617083508']!,
];

export const MOCK_OPTIMIZATION_STATE: OptimizationState = {
  currentVariationId: null,
  currentExperienceId: null,
  customerId: MOCK_OPTIMIZATION_JSON.id,
  currentModal: null,
  isCurrentVariationBase: true,
  currentMetric: null,
  prevDataCollectionEnabled: false,
  dataCollectionEnabled: false,
  prevDataCollectionType: 'always',
  dataCollectionType: 'always',
  publishedDataCollectionEnabled: false,
  publishedDataCollectionType: 'always',
  antiFlickerTimeout: null,
  publishedAntiFlickerTimeout: null,
  viewParams: {
    showOptimizationCreationTooltip: false,
  },
  isAiSuggestionChatOpen: false,
  currentPlaybookId: null,
  playbookCustomPrompt: null,
  isExperiencePopoverOpen: false,
  optimizationChangedPopoverIsOpen: false,
  isApplyingOptimizationWrappers: false,
  wrapperPublishingOptimizationName: null,
  shouldPublishApplyVariation: false,
  isPublishingApplyVariation: false,
};

export const MOCK_PERSONALIZE_OPTIMIZATION_JSON: OptimizationJson = {
  id: '117597989',
  name: 'mock-name',
  pages: {},
  events: {},
  audiences: {},
  version: 0,
  metrics: [],
  primaryMetricsIdSet: new Set(),
  primaryMetricType: 'CUSTOMER_NONE',
  optimizationMetrics: [],
  vertical: 'b2b',
  goalLabel: undefined,
  iint: {},
  customAttributeFilters: [],
  urlParamFilters: [],
  totalMetrics: undefined,
  origins: [],
  experiences: {
    '417219064': {
      id: '417219064',
      campaignId: '217219064',
      name: 'mock-personalize-optimization',
      type: 'rbp',
      variationPriority: ['617083510', '617083508', '617083500'],
      campaignName: '217219064 campaign',
      expTypeLabel: '',
      status: 'live',
      searchStringArray: [],
      statusLabel: 'Live',
      updatedAt: new Date('01/01/2025'),
      primaryGoal: {
        name: 'Total Revenue',
        metricIds: [],
        metricType: 'CUSTOMER_ALL',
      },
      selectedCustomerMetricIds: [],
      playbookId: null,
      userGuidance: null,
      pageIds: [],
      audienceIds: [],
      disableStateChanges: false,
      disableChanges: false,
      updatedAtLabel: '',
      primaryMetricSynthetic: undefined,
      metrics: [],
      variations: {
        '617083500': {
          condition: {
            type: 'audience',
            audienceId: '187599831',
          },
          name: 'Base',
          state: 'draft',
          statusLabel: 'Draft',
          isBaseVariation: true,
          isRbpFallBack: false,
          isRedirectVariation: false,
          isMissingPageData: false,
          experienceId: '417219064',
          id: '617083500',
        },
        '617083510': {
          condition: {
            type: 'audience',
            audienceId: '187599832',
          },
          name: 'Variation A',
          state: 'draft',
          statusLabel: 'Draft',
          isBaseVariation: false,
          isRbpFallBack: false,
          isRedirectVariation: false,
          isMissingPageData: false,
          experienceId: '417219064',
          id: '617083510',
        },
        '617083508': {
          condition: {
            type: 'audience',
            audienceId: '187599833',
          },
          name: 'Variation B',
          state: 'draft',
          statusLabel: 'Draft',
          isBaseVariation: false,
          isRbpFallBack: false,
          isRedirectVariation: false,
          isMissingPageData: false,
          experienceId: '417219064',
          id: '617083508',
        },
      },
    },
  },
};
